const isNull = (param) => param === null
export const isEmpty = (array = []) => array.length === 0
export const isNotEmpty = (array = []) => array.length !== 0

class Level {
  constructor({
    levelName = null,
    levelId = null,
    groupId = null,
    groupName = null,
  } = {}) {
    this.levelName = isNull(levelName) ? null : levelName
    this.levelId = isNull(levelId) ? null : levelId
    this.groupId = isNull(groupId) ? null : groupId
    this.groupName = isNull(groupName) ? null : groupName
  }

  copyWith({
    levelName = null,
    levelId = null,
    groupId = null,
    groupName = null,
  } = {}) {
    return new Level({
      levelName: isNull(levelName) ? this.levelName : levelName,
      levelId: isNull(levelId) ? this.levelId : levelId,
      groupId: isNull(groupId) ? this.groupId : groupId,
      groupName: isNull(groupName) ? this.groupName : groupName,
    })
  }
}

export const parseLevels = ({ levels } = {}) =>
  levels.map((e) => new Level({ levelId: e.id, levelName: e.typeLevel }))
export const parseGroups = ({ gradeGroups } = {}) =>
  gradeGroups
    .map((e) =>
      e.gradeGroups.map(
        (x) =>
          new Level({
            groupId: x.id,
            levelId: e.id,
            groupName: `${x.grade} ${x.group}`,
          })
      )
    )
    .flat()
/**
 * levelIds - Is a list of levelsIds
 *
 * posibleGroups - Receives a is a list of groups(all posible groups)
 *
 * Return a list of groups
 * */
export const filterByLevel = ({ levelIds = [], posibleGroups = [] }) =>
  levelIds.map((e) => posibleGroups.filter((x) => x.levelId == e)).flat()
/**
 *
 * Return a list of levels
 */
export const filterByGroup = ({
  groupsIds = [],
  posibleGroups = [],
  posibleLevels = [],
}) => {
  const selectedGroupsLevelsIds = Array.from(
    new Set(
      groupsIds
        .map((e) => posibleGroups.filter((a) => a.groupId === e))
        .flat()
        .map((e) => e.levelId)
    )
  )
  const levels = selectedGroupsLevelsIds
    .map((e) => posibleLevels.filter((x) => x.levelId === e))
    .flat()
  return levels
}

export class Student {
  constructor({
    id = null,
    dateIn = null,
    dateOut = null,
    minutesLate = null,
    attendanceType = null,
    createdAt = null,
    level = null,
    gradeGroup = null,
    firstName = null,
    lastName = null,
    personId = null,
    notes = undefined,
  } = {}) {
    this.id = isNull(id) ? null : id
    this.dateIn = isNull(dateIn) ? null : dateIn
    this.dateOut = isNull(dateOut) ? null : dateOut
    this.minutesLate = isNull(minutesLate) ? null : minutesLate
    this.attendanceType = isNull(attendanceType) ? null : attendanceType
    this.createdAt = isNull(createdAt) ? null : createdAt
    this.level = isNull(level) ? null : level
    this.gradeGroup = isNull(gradeGroup) ? null : gradeGroup
    this.firstName = isNull(firstName) ? null : firstName
    this.lastName = isNull(lastName) ? null : lastName
    this.personId = isNull(personId) ? null : personId
    this.notes = notes
  }

  copyWith({
    id = null,
    dateIn = null,
    dateOut = null,
    minutesLate = null,
    attendanceType = null,
    createdAt = null,
    level = null,
    gradeGroup = null,
    firstName = null,
    lastName = null,
    personId = null,
  } = {}) {
    return new Student({
      id: isNull(id) ? this.id : id,
      dateIn: isNull(dateIn) ? this.dateIn : dateIn,
      dateOut: isNull(dateOut) ? this.dateOut : dateOut,
      minutesLate: isNull(minutesLate) ? this.minutesLate : minutesLate,
      attendanceType: isNull(attendanceType)
        ? this.attendanceType
        : attendanceType,
      createdAt: isNull(createdAt) ? this.createdAt : createdAt,
      level: isNull(level) ? this.level : level,
      gradeGroup: isNull(gradeGroup) ? this.gradeGroup : gradeGroup,
      firstName: isNull(firstName) ? this.firstName : firstName,
      lastName: isNull(lastName) ? this.lastName : lastName,
      personId: isNull(personId) ? this.personId : personId,
    })
  }
}

export const parseStudents = ({ students = [] }) =>
  students.map((e) => new Student(e))

/**
 * @param {Array} obj - Object to parse
 * @returns {Array<AttendanceCount>}
 */
export const AttendanceCountList = (obj = []) =>
  obj.map((e) => new AttendanceCount(e))

/** @class AttendanceCount */
export class AttendanceCount {
  /**
   * @param  {({ type:string|null|undefined,count:string|null|undefined })} [param] - Description
   */
  constructor({ type = null, count = 0 } = {}) {
    this.type = isNull(type) ? null : type
    this.count = isNull(count) ? null : count
  }

  /**
   * @param  {({ type:string|null|undefined,count:string|null|undefined })} [param] - Description
   * @returns {AttendanceCount} - New cloned instance of -> @class AttendanceCount
   */
  copyWith({ type = null, count = null } = {}) {
    return new AttendanceCount({
      type: isNull(type) ? this.type : type,
      count: isNull(count) ? this.count : count,
    })
  }
}
